import apiClient from '../config/api';

export const pmStandardService = {
  getMyTasks: async (filters = {}) => {
    const response = await apiClient.get('/pm-standard-transaction/my-tasks', {
      params: filters
    });
    return response.data;
  },

  getTransactions: async (params = {}) => {
    const response = await apiClient.get('/pm-standard-transaction', {
      params,
    });
    return response.data;
  },

  logTransaction: async (data) => {
    const response = await apiClient.post('/pm-standard-transaction', data);
    return response.data;
  },

  getHistory: async (standardId) => {
    const response = await apiClient.get(`/pm-standard-transaction/history/${standardId}`);
    return response.data;
  },
  
  getCalendarSummary: async (startDate, endDate, filters = {}) => {
    const response = await apiClient.get('/pm-standard-transaction/calendar-summary', {
      params: { startDate, endDate, ...filters }
    });
    return response.data;
  },

  getDayTasks: async (date, filters = {}) => {
    const response = await apiClient.get('/pm-standard-transaction/day-tasks', {
      params: { date, ...filters }
    });
    return response.data;
  },

  getTechnicianTeams: async (tenantId) => {
    const response = await apiClient.get('/pm-masterdata/technician-teams', {
      params: { tenantId }
    });
    return response.data;
  },

  getMaintenanceWindows: async (tenantId) => {
    const response = await apiClient.get('/pm-masterdata/maintenance-windows', {
      params: { tenantId }
    });
    return response.data;
  },

  getNotificationSettings: async () => {
    const response = await apiClient.get('/pm-notification-settings');
    return response.data;
  },

  saveNotificationSettings: async (settings) => {
    const response = await apiClient.post('/pm-notification-settings', settings);
    return response.data;
  },

  getPmOverdueReport: async (plantIds = [], lineIds = [], machineIds = []) => {
    const response = await apiClient.get('/pm-reports/overdue', {
      params: { 
        plantIds: plantIds.length > 0 ? plantIds : null,
        lineIds: lineIds.length > 0 ? lineIds : null,
        machineIds: machineIds.length > 0 ? machineIds : null
      },
      paramsSerializer: params => {
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          const val = params[key];
          if (val === null || val === undefined) return;
          if (Array.isArray(val)) {
            val.forEach(v => searchParams.append(key, v));
          } else {
            searchParams.append(key, val);
          }
        });
        return searchParams.toString();
      }
    });
    return response.data;
  },

  getPmComplianceReport: async (startDate, endDate, plantIds = [], lineIds = [], machineIds = []) => {
    const response = await apiClient.get('/pm-reports/compliance', {
      params: { 
        startDate, 
        endDate,
        plantIds: plantIds.length > 0 ? plantIds : null,
        lineIds: lineIds.length > 0 ? lineIds : null,
        machineIds: machineIds.length > 0 ? machineIds : null
      },
      paramsSerializer: params => {
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          const val = params[key];
          if (val === null || val === undefined) return;
          if (Array.isArray(val)) {
            val.forEach(v => searchParams.append(key, v));
          } else {
            searchParams.append(key, val);
          }
        });
        return searchParams.toString();
      }
    });
    return response.data;
  },
  
  getIndividualPmTaskReport: async (startDate, endDate, frequency = null, status = null, plantIds = [], lineIds = [], machineIds = []) => {
    const response = await apiClient.get('/pm-reports/individual-tasks', {
      params: { 
        startDate, 
        endDate, 
        frequency, 
        status,
        plantIds: plantIds.length > 0 ? plantIds : null,
        lineIds: lineIds.length > 0 ? lineIds : null,
        machineIds: machineIds.length > 0 ? machineIds : null
      },
      paramsSerializer: params => {
        // Correctly serialize arrays for ASP.NET Core: plantIds=1&plantIds=2
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          const val = params[key];
          if (val === null || val === undefined) return;
          if (Array.isArray(val)) {
            val.forEach(v => searchParams.append(key, v));
          } else {
            searchParams.append(key, val);
          }
        });
        return searchParams.toString();
      }
    });
    return response.data;
  }
};

export default pmStandardService;
